import React from 'react';

const Footer = () => {
    return (
        <div className="bg-primary p-5">
            <small><p className="text-white text-center">&copy;copyright of Drones Center 2021</p></small>
        </div>
    );
};

export default Footer;